import { create } from "zustand";
import { DELETE, GET, POST, Signin, SignOut, UPDATE } from "../services/MainApi";
import toast from "react-hot-toast";




export const useAuthStore = create((set, get) => ({
  auth: null,
  expiration: localStorage.getItem("expiration")||"1440",
  isCheckingAuth: true,
  isLoggingOut: false,
  isSigningUp: false,
  isLoggingIn: false,
  isUploading: null,
  socket: null,
  onlineUsers: [],
  








   
  setExpiration : (value) => {
    localStorage.setItem("expiration",value)
    set({ expiration: value});
  },
  
  checkAuth : async () => {
    set({ isCheckingAuth: true });

  try {
    
  
    const res = await GET(null,'checkAuth.php',null);
    
     
  
      set({ 
        auth: res.data.auth,
       });


   
     
   

    } catch (error) {
  get().logout();
        console.log("Error In checkAuth: ",error)
    
  }finally{
   set({ isCheckingAuth: false });
  }


},

 


 // eslint-disable-next-line no-dupe-keys
 login : async (data) => {
    set({ isLoggingIn: true });

  try {
 const res = await Signin(data);  
  if (res.success) {
       get().checkAuth()

      } else {
        toast.error(res.msg);
      }
     
    } catch (error) {
        
        console.log("Error In login: ",error)
    
  }finally{
   set({ isLoggingIn: false });
  }


},

 




  
 // eslint-disable-next-line no-dupe-keys
 logout : async () => {
    set({ isLoggingOut: true });

  try {
    
     await SignOut();
     set({  auth: null });


    } catch (error) {
        
        console.log("Error In logout: ",error)

  }finally{
   set({ isLoggingOut: false });
  }


},




}));
